// extracted by mini-css-extract-plugin
module.exports = {"signup-mgm__depoiment__image":"Testimonial_signup-mgm__depoiment__image__Eb7NY","signup-mgm__depoiment__quote":"Testimonial_signup-mgm__depoiment__quote__YzhmB"};